import { RouteObject } from 'react-router-dom';
import { Credits } from './Credits';

export const creditsRoute: RouteObject = {
  path: 'credits',
  element: <Credits />,
};
